"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getContext = exports.addContextHandler = exports.Provider = void 0;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var context = {}; // == 将组件封装为Provider组件

var Provider = function Provider(name, Component) {
  if (!name) throw new Error('name不能为空!');
  if (!Component) throw new Error('Component不能为空!');
  context[name] = context[name] || {};
  return function (props) {
    var key = props.id || (0, _uuid.v4)();
    context[name][key] = {};
    return Component(_objectSpread2(_objectSpread2({}, props), {}, {
      context: context[name][key]
    }));
  };
};
/**
 * context处理器
 * @param name Provider组件名称
 * @param handler 处理方法
 * @param instance Provider组件实例ID
 */


exports.Provider = Provider;

var addContextHandler = function addContextHandler(name, handler, instance) {
  if (!name) throw new Error('Provider name不能为空!');
  if (!handler) throw new Error('Provider handler不能为空');
  var ctx = context[name];

  if (!ctx) {
    handler(null);
    return handler;
  } // == string类型则处理为单个ID


  if (typeof instance === 'string' && instance !== '') {
    var pid = instance;
    handler(ctx[pid] ? _objectSpread2({}, ctx[pid]) : null);
    return handler;
  } // == 数组类型处理为多个ID


  if (Array.isArray(instance) && instance.length) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = instance[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _pid = _step.value;
        handler(ctx[_pid] ? _objectSpread2({}, ctx[_pid]) : null);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return handler;
  } // == 其余情形使用批量方式


  for (var _i = 0, _Object$keys = Object.keys(ctx); _i < _Object$keys.length; _i++) {
    var _pid2 = _Object$keys[_i];
    handler(_objectSpread2({}, ctx[_pid2]));
  }

  return handler;
};
/**
 * 获取context
 * @param name Provider组件名称
 * @param instance Provider组件ID
 */


exports.addContextHandler = addContextHandler;

var getContext = function getContext(name, instance) {
  if (!name) throw new Error('Provider name不能为空!');
  var ctx = context[name];
  if (!ctx) return null; // == string类型则处理为单个ID

  if (typeof instance === 'string' && instance !== '') {
    var pid = instance;
    if (!ctx[pid]) return null;
    return _objectSpread2({}, ctx[pid]);
  } // == 数组类型处理为多个ID


  if (Array.isArray(instance) && instance.length) {
    var _results = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = instance[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _pid3 = _step2.value;
        if (!ctx[_pid3]) continue;

        _results.push(_objectSpread2({}, ctx[_pid3]));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return _results;
  } // == 其余情形使用批量方式


  var results = [];

  for (var _i2 = 0, _Object$keys2 = Object.keys(ctx); _i2 < _Object$keys2.length; _i2++) {
    var _pid4 = _Object$keys2[_i2];
    results.push(_objectSpread2({}, ctx[_pid4]));
  }

  return results;
};

exports.getContext = getContext;
var _default = {
  Provider: Provider,
  addContextHandler: addContextHandler,
  getContext: getContext
};
exports["default"] = _default;